import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CoinsHand = function CoinsHand(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M13.5295 8.3519A3.484 3.484 0 0 1 11.5 9C9.567 9 8 7.433 8 5.5S9.567 2 11.5 2c1.253 0 2.3522.6584 2.9705 1.6481M6 20.0872h2.6103c.3403 0 .6786.0405 1.0085.1214l2.7581.6703a4.28 4.28 0 0 0 1.8266.0425l3.0495-.5933c.8055-.1569 1.5466-.5427 2.1273-1.1076l2.1576-2.0988c.6161-.5983.6161-1.5693 0-2.1686-.5547-.5397-1.4332-.6004-2.0608-.1428l-2.5145 1.8346c-.3601.2632-.7983.4049-1.2489.4049h-2.4282 1.5456c.8711 0 1.5768-.6865 1.5768-1.5339v-.3068c0-.7036-.4923-1.3171-1.1938-1.4872l-2.3855-.5802A5.03 5.03 0 0 0 11.6431 13c-.9648 0-2.7112.7988-2.7112.7988L6 15.0249M20 6.5c0 1.933-1.567 3.5-3.5 3.5S13 8.433 13 6.5 14.567 3 16.5 3 20 4.567 20 6.5M2 14.6v5.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C2.76 22 3.04 22 3.6 22h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C6 21.2401 6 20.9601 6 20.4v-5.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C5.24 13 4.96 13 4.4 13h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C2 13.7599 2 14.0399 2 14.6"
    })
  }));
};
export default CoinsHand;